import { Container } from 'reactstrap';
import { useEffect, useState, useRef } from 'react';

import WarehouseHeader from './Components/WareHouseHeader';
import TableMCT from './Components/Tables/TableMCT/TableMCT';
import TableSRBM from './Components/Tables/TableSRBM/TableSRBM';
import TableHub from './Components/Tables/TableHub/TableHub';
import TableSTM from './Components/Tables/TableSTM/TableSTM';
import TableSTR from './Components/Tables/TableSTR/TableSTR';
import GetTrapByTokenModal from './Components/Modals/GetTrapByTokenModal/GetTrapByTokenModal';

import useGetDevicesInWarehouse from 'hooks/Traps/DeviceWarehouse/useGetDevicesWarehouse';
import QRCodeModal from 'components/QRCodeModal/QRCodeModal';
import TrapDeleteModal from 'components/DeleteTrapModal/TrapsDeleteModal';
import HubDeleteModal from 'components/DeleteHubModal/HubsDeleteModal';
import './DevicesWarehouse.scss';
import { HubData } from 'api/traps/Hubs/types';
import { useHubDeleteModalStore } from 'components/DeleteHubModal/HubsDeleteStore';

const DevicesWarehouse: React.FC = () => {
  const [isAll, setIsAll] = useState<boolean>(false);
  const isAllRef = useRef(isAll);
  const { data, isLoading, refetch, isRefetching } = useGetDevicesInWarehouse(isAll);
  const { hubObjectSlug } = useHubDeleteModalStore();

  useEffect(() => {
    isAllRef.current = isAll;
    refetch();
  }, [isAll, refetch]);

  return (
    <div className="page-content devices-warehouse">
      <Container fluid>
        <WarehouseHeader isAll={isAll} setIsAll={setIsAll} />
        <div className="row d-flex align-items-stretch">
          <div className="col-xxl-6 col-xl-12 mb-3 d-flex px-xl-0 pe-xxl-2">
            {' '}
            <TableMCT
              isAll={isAllRef.current}
              data={data?.mct}
              isLoading={isLoading}
              isRefetching={isRefetching}
              refetch={refetch}
            />
          </div>
          <div className="col-xxl-6 col-xl-12 mb-3 d-flex px-xl-1 ps-xxl-2">
            {' '}
            <TableSRBM
              isAll={isAllRef.current}
              data={data?.srbm}
              isLoading={isLoading}
              isRefetching={isRefetching}
              refetch={refetch}
            />
          </div>
        </div>
        <div className="row d-flex align-items-stretch">
          <div className="col-xxl-6 col-xl-12 mb-3 d-flex px-xl-0 pe-xxl-2">
            <TableSTM
              isAll={isAllRef.current}
              data={data?.smst}
              isLoading={isLoading}
              isRefetching={isRefetching}
              refetch={refetch}
            />
          </div>
          <div className="col-xxl-6 col-xl-12 mb-3 d-flex px-xl-1 ps-xxl-2">
            <TableSTR
              isAll={isAllRef.current}
              data={data?.srst}
              isLoading={isLoading}
              isRefetching={isRefetching}
              refetch={refetch}
            />
          </div>
        </div>
        <div className="row d-flex align-items-stretch px-xl-0">
          <TableHub
            isAll={isAllRef.current}
            data={data?.hub}
            isLoading={isLoading}
            isRefetching={isRefetching}
            refetch={refetch}
          />
        </div>
        <QRCodeModal />
        <GetTrapByTokenModal refetchWarehouse={refetch} />
        <TrapDeleteModal refetchTraps={refetch} refetchWarehouse={refetch} />
        <HubDeleteModal
          hubs={data?.hub.filter(hub => hub.object_slug === hubObjectSlug) as unknown as HubData[]}
          refetchHubs={refetch}
        />
      </Container>
    </div>
  );
};

export default DevicesWarehouse;
